import { SUCCESS_RESPONSES, SUBSCRIPTION_REPORT_DETAILS_API } from 'constants/AppConstants';

export default async (reportIds) => {
  try {
    const response = await fetch(SUBSCRIPTION_REPORT_DETAILS_API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        reportIds,
      }),
    });
    const json = await response.json();
    if (response.status !== SUCCESS_RESPONSES.SUCCESS_OK) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
